export function countDown (counteDate) {
  var timestamp = parseInt(new Date(counteDate).getTime())
  let now = new Date().getTime()
  let gap = timestamp - now
  let seconds = 1000
  let minutes = seconds * 60
  let hours = minutes * 60
  let days = hours * 24
  let d = Math.floor(gap / days)
  let h = Math.floor((gap % days) / hours)
  let m = Math.floor((gap % hours) / minutes)
  let s = Math.floor((gap % minutes) / seconds)
  // console.log(`距离2027年还有 ${d} 天 ${h} 小时 ${m} 分钟 ${s} 秒 `);
  if (d < 10) {
    d = '0' + d
  } else {
    d = '' + d
  }
  if (h < 10) {
    h = '0' + h
  } else {
    h = '' + h
  }
  if (m < 10) {
    m = '0' + m
  } else {
    m = '' + m
  }
  if (s < 10) {
    s = '0' + s
  } else {
    s = '' + s
  }
  let overTime = {
    day: d,
    hour: h,
    minute: m,
    second: s,
  }
  if (d > 0 || h > 0 || m > 0 || s > 0) {
    return overTime
  } else {
    return false
  }
}
//时间格式转下2022-10-11
export function changeDateStr (str) {
  let newstr = str.split('-').join('/')
  return newstr
}
//时间戳转标准时间格式
export function filterTime (time) {
  const date = time ? new Date(time) : new Date()
  const Y = date.getFullYear()
  const M =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
  const D = date.getDate()
  return `${Y}-${M}-${D}`
}
//计算多少岁
export function howAge (birthday) {
  //现在的年月日
  const nowDate = new Date()
  const nowYear = nowDate.getFullYear()
  const nowMonth = nowDate.getMonth()
  const nowDay = nowDate.getDate()
  //出生年月日
  const lastDate = new Date(birthday)
  const lastYear = lastDate.getFullYear()
  const lastMonth = lastDate.getMonth()
  const lastDay = lastDate.getDate()
  let age = 0
  if (nowMonth > lastMonth) {
    age = nowYear - lastYear
  } else if (nowMonth == lastMonth && nowDay >= lastDay) {
    age = nowYear - lastYear
  } else {
    age = nowYear - lastYear - 1
  }
  return age
}
export function dateContrast (startDate, endDate) {
  let nowDateTime = new Date().getTime()
  let startDateTime = new Date(startDate).getTime()
  let endDateTime = new Date(endDate).getTime() + 24 * 60 * 60 * 1000
  //结束时间小于当前时间，已结束
  if (endDateTime < nowDateTime) {
    return 1
  }
  //开始时间大于当前时间，未开始
  if (startDateTime > nowDateTime) {
    return 2
  }
  return 3
}
/**
   *格式化当前日期
   * @returns
   * 0.是当前时间
   * 1.是近一周
   * 2.是近一个月
   * 3.近半年
   * 4.近一年
   */
export function getNowDate (num = 0) {
  var date = new Date()
  var nowDate = []
  var nowTime = []
  //近一年
  if (num == 4) {
    nowDate.push(date.getFullYear() - 1)
  } else {
    nowDate.push(date.getFullYear())
  }
  //近一个月
  if (num == 2) {
    if (date.getMonth() < 10) {
      nowDate.push('0' + date.getMonth())
    } else {
      nowDate.push(date.getMonth())
    }
    //近半年
  } else if (num == 3) {
    if (date.getMonth() - 5 < 10) {
      nowDate.push('0' + date.getMonth() - 5)
    } else {
      nowDate.push(date.getMonth() - 5)
    }
  } else {
    if (date.getMonth() + 1 < 10) {
      nowDate.push('0' + date.getMonth() + 1)
    } else {
      nowDate.push(date.getMonth() + 1)
    }
  }
  //近一周
  if (num == 1) {
    var dateTime = new Date().getTime()
    dateTime = dateTime - 7 * 24 * 60 * 60 * 1000
    date = new Date(dateTime)
    if (date.getDate() < 10) {
      nowDate.push('0' + date.getDate())
    } else {
      nowDate.push(date.getDate())
    }
  } else {
    if (date.getDate() < 10) {
      nowDate.push('0' + date.getDate())
    } else {
      nowDate.push(date.getDate())
    }
  }
  if (date.getHours() < 10) {
    nowTime.push('0' + date.getHours()) // 小时
  } else {
    nowTime.push(date.getHours()) // 小时
  }
  
  if (date.getMinutes() < 10) {
    nowTime.push('0' + date.getMinutes()) // 分钟
  } else {
    nowTime.push(date.getMinutes()) // 分钟
  }
  
  if (date.getSeconds() < 10) {
    nowTime.push('0' + date.getSeconds()) // 秒
  } else {
    nowTime.push(date.getSeconds()) // 秒
  }
  
  return nowDate.join('-') + ' ' + nowTime.join(':')
}



// WEBPACK FOOTER //
// ./src/comm/utils/handleDateTime.js